import type { Rect } from '../layout';
import {
  connectorLabelStyle,
  highlightedConnectorLabelStyle,
} from './connector-label-style';

interface ConnectorLabelProps {
  rect: Readonly<Rect>;
  text: string;
  isHighlighted: boolean;
}

const ConnectorLabel = ({ rect, text, isHighlighted }: ConnectorLabelProps) => (
  <div
    style={{
      ...(isHighlighted ? highlightedConnectorLabelStyle : connectorLabelStyle),
      left: rect.x,
      top: rect.y,
      width: rect.width,
      height: rect.height,
    }}
  >
    {text}
  </div>
);

export { ConnectorLabel };
